import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GenericResourceService } from '@mri/app/resources';
import { AnyObject, Hardware, SensorDataHardware } from '@mri/types';
import { map, mergeMap, Observable, Subject, Subscription, tap } from 'rxjs';
import { CardComponent } from '../../@theme/components/card/card.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FieldExpressionModule } from '../inputs/field-expression';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ClipboardPaneComponent } from '../clipboard-pane';

@Component({
  selector: 'app-sensors-config',
  templateUrl: './sensors-config.component.html',
  standalone: true,
  imports: [
    CardComponent,
    MatButtonModule,
    MatSlideToggleModule,
    FieldExpressionModule,
    ClipboardPaneComponent
  ],
  styleUrl: './sensors-config.component.scss'
})
export class SensorsConfigComponent implements OnInit, OnDestroy {

  private _subscription = new Subscription();
  private _submit$ = new Subject<Hardware | undefined>();

  inputOptionsUrl = 'positions/attributes/choice';
  sensors: SensorDataHardware[] = [];
  isSubmitting: boolean;
  hardware?: Hardware;

  @Input()
  hardwareId: string;

  constructor(
    private _genericSrcSrv: GenericResourceService,
    private _snackBar: MatSnackBar,
    private _cd: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this._subscription
      .add(
        this._brigSensors().pipe(
          mergeMap(() => this._brigHardware()),
          tap(() => this._organizeData()),
          tap(() => this._cd.markForCheck()),
          tap(() => this._cd.detectChanges())
        ).subscribe()
      );

    this._subscription.add(
      this._submit$.pipe(
        mergeMap(() => this._sendData()),
        tap(() => this._cd.markForCheck()),
        tap(() => this._cd.detectChanges())
      ).subscribe()
    );

  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }


  onSubmit() {
    this._submit$.next(this.hardware);
  }

  private _sendData(): Observable<AnyObject> {
    const hardware = this.hardware;
    const sensorConfig = this.sensors
      .filter(s => s.config?.enable)
      .map(s => ({ ...(s.config || {}), key: s.key }));
    Object.assign(hardware?.config || {}, { sensors: sensorConfig });

    this.isSubmitting = true;
    return this._genericSrcSrv
      .putElement(`hardware/${this.hardwareId}`, hardware)
      .pipe(
        tap(() => this.isSubmitting = false),
        tap(() => this._snackBar.open('Configuracion guardada correctamente!'))
      );
  }

  private _brigHardware(): Observable<Hardware> {
    return this._genericSrcSrv
      .getElement<Hardware>('hardware', this.hardwareId)
      .pipe(
        map(({ object }) => object),
        tap(hardware => this.hardware = hardware)
      );
  }

  private _organizeData() {
    const sensorConfigs = this.hardware?.config?.sensors;

    (this.sensors)
      .forEach((sensor, index) => {
        const config = sensorConfigs?.find(s => s.key === sensor.key);

        (this.sensors)[index].config = config || { key: sensor.key };
      });
  }

  private _brigSensors(): Observable<Array<SensorDataHardware>> {
    return this._genericSrcSrv
      .getElements<SensorDataHardware>(
        'sensors',
        { paginate: { page: 1, size: 99 } }
      )
      .pipe(
        map(({ objects }) => objects),
        tap(sensors => this.sensors = sensors)
      );
  }
}
